import { useMutation, useQuery } from 'react-query';

import type {
  OnboardingContract,
  OnboardingContractSignature,
  OnboardingContractType,
} from '@evenfinancial/finance-client';

import { client } from '../client';
import type { CustomQueryOptions } from '../types';
import { QueryKey } from '../types';

export const getOnboardingContracts = async () =>
  client
    .get<OnboardingContract[]>('/onboarding_contract')
    .then(({ data }) => data);

export const getOnboardingContractSignatures = async () =>
  client
    .get<OnboardingContractSignature[]>('/onboarding_contract/signed')
    .then(({ data }) => data);

export const signOnboardingContract = async (
  type: OnboardingContractType,
  userId: number
) =>
  client
    .post<OnboardingContractSignature>('/onboarding_contract/sign', {
      type,
      userId,
    })
    .then(({ data }) => data);

// React Query hooks
export const useGetOnboardingContracts = (options?: CustomQueryOptions) =>
  useQuery<OnboardingContract[], Error>({
    ...options,
    queryFn: getOnboardingContracts,
    queryKey: [QueryKey.OnboardingContracts],
  });

export const useGetOnboardingContractSignatures = (
  options?: CustomQueryOptions
) =>
  useQuery<OnboardingContractSignature[], Error>({
    ...options,
    queryFn: getOnboardingContractSignatures,
    queryKey: [QueryKey.OnboardingContractSignatures],
  });

type SignOnboardingContractParams = {
  type: OnboardingContractType;
  userId: number;
};

export const useSignOnboardingContract = () =>
  useMutation<OnboardingContractSignature, Error, SignOnboardingContractParams>(
    {
      mutationFn: ({ type, userId }) => signOnboardingContract(type, userId),
    }
  );
